import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPI } from "./api";
import accessComposition from "./composition";
import help from "help/viewAccessProfileConfig.md";
import settingsHelp from "help/viewAccessProfileConfigSettings.md";

const ConfigAccessProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...accessComposition}
    {...composedAPI}
    {...settings}
    help={help}
    settingsHelp={settingsHelp}
  />
);

export default ConfigAccessProfiles;
